import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { USERS_API_HOST } from './ApiService';

/**
 * @override
 */
class PublicService {
    /**
     * constructor
     */
    constructor() {
        const cfg = {
            baseURL: USERS_API_HOST,
            withCredentials: false,
            headers: {
                Accept: '*/*',
                'Content-Type': 'application/json',
                'X-Request-Id': uuidv4()
            }
        };
        this.connection = axios.create(cfg);
    }

    /**
     * @param {Object} config Axios config
     * @param {Object} body Axios config
     * @return {Object} Promise
     */
    passwordRequest(config, body) {
        return this.connection.post('/users/password-recover', body, config);
    }

    /**
     * @param {Object} config Axios config
     * @param {Object} body Axios config
     * @return {Object} Promise
     */
    passwordChange(config, body) {
        return this.connection.post('/users/password-change', body, config);
    }
}

const publicService = new PublicService();

export default publicService;
